import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const faqs = [{
  q: '¿Es un manual físico o digital?',
  a: 'Es 100% digital en formato PDF. Lo recibís por email inmediatamente después de la compra. Podés leerlo desde el celular, la tablet o la computadora.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No. El sistema está diseñado para empezar desde cero. El Tomo 1 arranca desde los conceptos más básicos y va subiendo de nivel progresivamente.'
}, {
  q: '¿Cuándo lo recibo después de comprar?',
  a: 'Inmediatamente. Revisá tu bandeja de entrada y también la carpeta de SPAM por las dudas.'
}, {
  q: '¿Qué herramientas necesito para empezar?',
  a: 'Con una soldadora inverter básica y una amoladora ya podés fabricar el 70% de los muebles del catálogo. El Tomo 1 te explica exactamente qué conseguir y en qué orden.'
}, {
  q: '¿Cuánto tardo en ver resultados?',
  a: 'El plan del Acelerador 24HS está diseñado para que tengas tu primera venta en 30 días. Los primeros muebles salen en la segunda semana.'
}, {
  q: '¿Puedo hacerlo si no tengo taller?',
  a: 'Sí. Podés empezar en el fondo de tu casa, en un garaje o en cualquier espacio con ventilación. El Bono #3 te enseña a organizar cualquier espacio para trabajar bien.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-white" data-id="element-70">
      <div className="max-w-3xl mx-auto" data-id="element-71">
        <h2 className="text-4xl font-black text-center text-brand-dark mb-12" data-id="element-72">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-73">
          {faqs.map((faq, index) => <div key={index} className="border-2 border-gray-100 rounded-xl overflow-hidden shadow-sm" data-id="element-74">
              <button className="w-full px-6 py-5 text-left bg-gray-50 hover:bg-gray-100 transition-colors flex justify-between items-center" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-75">
                <span className="font-bold text-lg text-brand-dark pr-4" data-id="element-76">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUpIcon className="w-6 h-6 text-brand-amber flex-shrink-0" data-id="element-77" /> : <ChevronDownIcon className="w-6 h-6 text-gray-400 flex-shrink-0" data-id="element-78" />}
              </button>

              {openIndex === index && <div className="px-6 py-5 bg-white text-gray-700 text-lg leading-relaxed border-t border-gray-100" data-id="element-79">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}